/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum OwnerType {
    OWNER_TYPE_USER = 'OWNER_TYPE_USER',
    OWNER_TYPE_CLIENT = 'OWNER_TYPE_CLIENT',
    OWNER_TYPE_COMPANY = 'OWNER_TYPE_COMPANY',
    OWNER_TYPE_SITE = 'OWNER_TYPE_SITE',
    OWNER_TYPE_OPERATOR = 'OWNER_TYPE_OPERATOR',
}
